
import { getDispatch } from 'redux/store';
import { ACTIONS_TYPES } from '../helper';

export default {
  setProvisioningItems: ({ provisioningItems }) => {
    const dispatch = getDispatch();

    return dispatch({
      type: ACTIONS_TYPES.PROVISIONING.ADD,
      payload: { provisioningItems },
    });
  },
};
